export const SITE_NAME = 'PULSE';
export const SITE_FULL_NAME = 'PULSE - ゲームを記録・管理できる究極のゲームライブラリ';
